var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiThemeLightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.25 75C214.125 118.125 168.75 194.25 168.75 281.25C168.75 368.25 214.125 444.375 282.375 487.5C167.25 487.5 75 395.25 75 281.25C75 226.549 96.7299 174.089 135.409 135.409C174.089 96.7299 226.549 75 281.25 75ZM715.125 131.25L768.75 184.875L184.875 768.75L131.25 715.125L715.125 131.25ZM483.375 222.375L427.875 187.5L373.875 225L389.625 161.25L337.5 121.5L403.125 117L424.875 55.125L450 116.25L514.875 117.375L464.25 159.75L483.375 222.375ZM359.625 357.75L316.125 330.375L274.125 359.625L286.875 310.125L246 279L297 275.625L313.875 227.25L333 274.875L384 276L344.625 308.625L359.625 357.75ZM712.5 506.25C712.5 560.951 690.77 613.411 652.091 652.091C613.411 690.77 560.951 712.5 506.25 712.5C460.5 712.5 418.125 697.5 384 672.375L672.375 384C697.5 418.125 712.5 460.5 712.5 506.25ZM547.5 753L651.375 709.875L642.375 835.5L547.5 753ZM709.875 651.75L753 547.875L835.5 643.125L709.875 651.75ZM753 465.75L710.25 361.5L835.5 370.5L753 465.75ZM361.125 709.875L465 753L370.125 835.125L361.125 709.875Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiThemeLightDark);
export default __webpack_public_path__ + "static/media/mdi_theme-light-dark.37094b00b174fed4852ee36209e38ba0.svg";
export { ForwardRef as ReactComponent };